<div class="rule-preview-wrapper">
  <div #previewContainer class="label-background" [style.background-image]="labelBackgroundImage()">
    <div class="label-background-scroll"
      [class.poe-scrollbar]="scrollable()"
      [class.no-scroll]="!scrollable()"
      [class.scattered]="layoutStyle() === 'scattered'"
      [class.stacked]="layoutStyle() === 'stacked'">
    <ng-template #labelViewer let-rule="rule" let-layer="layer">
      @if (rule.librarySimulatorResult && (rule.isItemLibraryItem || rule.isRandomLootItem || rule.isSimulatedTierItem)) {
        <div app-label-viewer
          [previewLayer]="layer || 'default'"
          [forceGlow]="forceGlow()"
          [forceVisible]="forceVisible()"
          [labelPreviewBgOverride]="labelPreviewBgOverride()"
          [disableBeam]="dimmedRuleOrders().has(rule.order)"
          [glowDimmed]="glowDimmedRuleOrders().has(rule.order)"
          [clickable]="true"
          (mouseEnterLabel)="onItemLibraryMouseEnter(rule, $event)"
          (mouseLeaveLabel)="onItemLibraryMouseLeave($event)"
          (clickLabel)="onLabelClick($event, rule)"
          [displayOptions]="rule.displayOptions"
          [isCurrency]="rule.itemClass === 'Stackable Currency' || rule.isCurrency || currencyItemTypes.includes(rule.itemType)"
          [exampleName]="exampleNames().get(rule.order) ?? 'Example'"
          [stackSize]="stackSizes().get(rule.order)"
          [rareName]="rule.rareName"
          [unidentifiedItemTier]="rule.unidentifiedItemTier"
          [rarity]="rule.rarity"
          [isWaystone]="rule.isWaystone ?? rule.itemClass === 'Waystones'"
          [influence]="rule.influence"
          [memoryStrands]="rule.memoryStrands"
          [fractured]="rule.fractured"
          [synthesised]="rule.synthesised"
          [veiled]="rule.veiled"
          [sockets]="rule.sockets"
          [isPoe1Gem]="rule.isPoe1Gem"
          [isDivinationCard]="rule.isDivinationCard"
          [isQuestItem]="rule.isQuestItem"
          [disableBackground]="true"></div>
      } @else {
        <div app-label-viewer
          [previewLayer]="layer || 'default'"
          [forceGlow]="forceGlow()"
          [forceVisible]="forceVisible()"
          [labelPreviewBgOverride]="labelPreviewBgOverride()"
          [disableBeam]="dimmedRuleOrders().has(rule.order)"
          [glowDimmed]="glowDimmedRuleOrders().has(rule.order)"
          (mouseEnterLabel)="onMouseEnter(rule)"
          (mouseLeaveLabel)="onMouseLeave(rule)"
          [displayOptions]="rule.displayOptions"
          [isCurrency]="rule.itemClass === 'Stackable Currency' || rule.isCurrency || currencyItemTypes.includes(rule.itemType)"
          [exampleName]="exampleNames().get(rule.order) ?? 'Example'"
          [stackSize]="stackSizes().get(rule.order)"
          [rareName]="rule.rareName"
          [unidentifiedItemTier]="rule.unidentifiedItemTier"
          [rarity]="rule.rarity"
          [isWaystone]="rule.isWaystone ?? rule.itemClass === 'Waystones'"
          [influence]="rule.influence"
          [memoryStrands]="rule.memoryStrands"
          [fractured]="rule.fractured"
          [synthesised]="rule.synthesised"
          [veiled]="rule.veiled"
          [sockets]="rule.sockets"
          [isPoe1Gem]="rule.isPoe1Gem"
          [isDivinationCard]="rule.isDivinationCard"
          [isQuestItem]="rule.isQuestItem"
          [disableBackground]="true"></div>
      }
    </ng-template>

    @if (layoutStyle() === 'stacked') {
      <div class="label-stacked-layout">
        @for (column of stackedLayout(); track $index) {
          <div class="label-column">
            @for (subStack of column; track $index) {
              <div class="label-column-sub-stack">
                <div class="label-column-stack">
                  <div class="label-column-effects">
                    @for (slot of subStack; track slot.rule.order) {
                      <div class="label-column-slot"
                        [style.--stack-index-in-chunk]="slot.indexInChunk"
                        [style.--stack-last-index-in-chunk]="slot.lastIndexInChunk"
                        [style.--stack-direction]="slot.direction">
                        <ng-container *ngTemplateOutlet="labelViewer; context: { rule: slot.rule, layer: 'effects' }"></ng-container>
                      </div>
                    }
                  </div>
                  <div class="label-column-labels">
                    @for (slot of subStack; track slot.rule.order) {
                      <div class="label-column-slot"
                        [style.--stack-index-in-chunk]="slot.indexInChunk"
                        [style.--stack-last-index-in-chunk]="slot.lastIndexInChunk"
                        [style.--stack-direction]="slot.direction">
                        <ng-container *ngTemplateOutlet="labelViewer; context: { rule: slot.rule, layer: 'label' }"></ng-container>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      @for (group of scatteredGroups(); track $index) {
        <div class="label-scattered-group">
          @for (rule of group; track rule.order) {
            <ng-container *ngTemplateOutlet="labelViewer; context: { rule }"></ng-container>
          }
        </div>
      }
    }
  </div>
  </div>

  @if (resizable()) {
    <div class="rule-preview-resize-handle"
      title="Drag to resize preview height"
      (mousedown)="onResizeHandleMouseDown($event)">
      <span class="icon icon-resize-right" aria-hidden="true"></span>
    </div>
  }

  @if (hoveredLibraryRule(); as libraryRule) {
    @if (libraryRule.librarySimulatorResult; as simulatorResult) {
      @if (itemLibraryTooltipPosition(); as tooltipPosition) {
        <div #floatingTooltip
          class="item-library-floating-tooltip"
          [style.top.px]="tooltipPosition.top"
          [style.left.px]="tooltipPosition.left"
          (mouseenter)="onTooltipMouseEnter()"
          (mouseleave)="onItemLibraryTooltipMouseLeave()">
          @if (libraryRule.isDivinationCard) {
            <app-divcard-viewer
              [name]="simulatorResult.item.baseType"
              [tooltipOnly]="true"
              [showDropInfo]="showDropInfo()">
            </app-divcard-viewer>
          } @else {
            <app-item-label
              [baseType]="simulatorResult.item.baseType"
              [gameItem]="simulatorResult.item"
              [tooltipOnly]="true"
              [showItemLibraryRemoveHint]="libraryRule.isItemLibraryItem ?? false"
              [showRandomLootAddHint]="libraryRule.isRandomLootItem ?? false"
              [showSimulatorRuleInfo]="libraryRule.isSimulatedTierItem ?? false"
              [showCopyItemTextHint]="!!libraryRule.itemLibraryText?.startsWith('Item Class: ')"
              [simulatorResult]="simulatorResult">
            </app-item-label>
          }
        </div>
      }
    }
  }
</div>
